var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 55"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 12",
    x: 0.5,
    y: 0.5,
    width: 54,
    height: 54,
    rx: 9.5,
    stroke: "#B6F09A",
    strokeOpacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.9999 31.811L19 28L26.9999 42L35 28L26.9999 31.811Z",
    fill: "#45A2ED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M34 24.9862L27.0039 13L20 25L27.0039 21.7226L34 24.9862Z",
    fill: "#45A2ED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20 27.0024L26.9941 30L34 26.9974L26.9941 24L20 27.0024Z",
    fill: "#45A2ED"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/eth.f339ed36d2e19a1e7fdced5b0646751a.svg";
export { ForwardRef as ReactComponent };